// extracted by mini-css-extract-plugin
export default {"reportName":"PageTcbReports_reportName__gqLwD"};